import * as yup from "yup";

export function fieldValidation(validations, fieldName, label, field = null) {
    let schemaData;

    validations.map(function (validation) {
        if (!validation) {
            return;
        }

        if (validation === "string") {
            schemaData = yup.string();
        }

        if (validation === "integer") {
            schemaData = yup.number();
        }

        if (validation === "array") {
            schemaData = yup.array();
        }

        if (validation === "object") {
            schemaData = yup.object();
        }

        if (validation === "boolean") {
            schemaData = yup.boolean();
        }

        if (validation === "date") {
            schemaData = yup.date();
        }

        if (validation === "email") {
            schemaData = schemaData.email('Must be a valid email Address');
        }

        if (validation === "nullable") {
            schemaData = schemaData.nullable(true);
        }

        if (validation === "phone") {
            // yup.number() casts a blank field to NaN and fails it as "not a number",
            // so an optional phone left empty blocked the whole form. Treat blank as
            // no value: optional phones pass, and a required one reports "is required".
            schemaData = schemaData
                .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value))
                .typeError('Must be a valid '+ label +' number only');
        }

        if (validation === "required") {
            schemaData = schemaData.required(label + " is required");
        }

        if (validation.startsWith("required_if_")) {
            const match = validation.match(/^required_if_([^_]+(?:_[^_]+)*)_([^_]*)$/);
            if (match) {
                const depField = match[1];
                const rawVal = match[2];

                const depValue =
                    rawVal !== "" && !Number.isNaN(Number(rawVal)) ? Number(rawVal) : rawVal;

                schemaData = schemaData.when(depField, {
                    is: depValue,
                    then: (s) => s.required(label + " is required"),
                    otherwise: (s) => s,
                });
            }
        }

        if (validation === "max_initial") {
            schemaData = schemaData.test(
                "max-initial",
                label + " can not be greater than existing date",
                function (value) {
                    const initial = field && field.initial_value;

                    if (!initial) return true;

                    if (value === null || value === undefined || value === "") return true;

                    const initialDate = new Date(initial);
                    const currentDate = new Date(value);

                    if (Number.isNaN(initialDate.getTime()) || Number.isNaN(currentDate.getTime())) {
                        return true;
                    }

                    return currentDate.getTime() <= initialDate.getTime();
                }
            );
        }

        if (validation === "not_null_if_initial") {
            schemaData = schemaData.test(
                "not-null-if-initial",
                label + " can not be empty (existing value already saved)",
                function (value) {
                    const initial = field && field.initial_value;

                    if (!initial) return true;

                    return !(value === null || value === undefined || value === "");
                }
            );
        }

        if (validation.includes("min:")) {
            const minVal = parseInt(validation.replace(/\D/g, ""));
            schemaData = schemaData.min(minVal, label + " should be minimum of " + minVal + " ");
        }

        if (validation.includes("max:")) {
            const maxVal = parseInt(validation.replace(/\D/g, ""));
            schemaData = schemaData.max(maxVal, label + " should be maximum of " + maxVal + " ");
        }
    });

    return schemaData;
}
